import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M10.356 5.643a3.333 3.333 0 1 1-4.714 4.714 3.333 3.333 0 0 1 4.714-4.714M8 2.667V1.333M8 14.667v-1.334M12.24 3.76l.473-.473M3.286 12.713l.473-.473M13.333 8h1.333M1.333 8h1.333M12.24 12.24l.473.473M3.286 3.287l.473.473"
    }, null, -1)
  ])))
}
export default { render: render }